import { render, staticRenderFns } from "./LastPurchaseDetails.vue?vue&type=template&id=5b87a610&scoped=true&"
import script from "./LastPurchaseDetails.vue?vue&type=script&lang=js&"
export * from "./LastPurchaseDetails.vue?vue&type=script&lang=js&"
import style0 from "./LastPurchaseDetails.vue?vue&type=style&index=0&id=5b87a610&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b87a610",
  null
  
)

export default component.exports